import { Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { APGTestingService } from '../agptesting-newview/apgtesting.service';
import { APGCovid19Constants } from '../agptesting-newview/model/apg-newview-constants';
import { CovidSamples } from '../agptesting-newview/model/covid-sample';
import { Covid19Batch, RunLane, WellType } from '../agptesting-newview/model/covid19Batch';
import { MasterDataService } from '../masterdata/masterdata.service';
import { LabMDM, SelectableLab } from '../masterdata/models/lab';
import { SenderDTO } from '../masterdata/models/sender-dto';
import { MessagesService } from '../messages/messages.service';
import { ErrorHandler } from '../utils/error-handler';
import { MidplexSamplesService } from './midplex-samples.service';
import { saveAs as saveByFileSaver } from "file-saver";
import { PlateViewComponent } from '../plate-view/plate-view.component';
import { BatchGroup } from '../agptesting-newview/model/batchGroup';
import { BatchItemHistory } from '../agptesting-newview/model/batchItemHistory';
import { MergedBatch } from '../agptesting-newview/model/merged-batch';
import { Comment } from '../agptesting-newview/model/comment';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
  selector: 'app-midplex-samples',
  templateUrl: './midplex-samples.component.html',
  styleUrls: ['./midplex-samples.component.css']
})
 
export class MidplexSamplesComponent implements OnInit {

  @ViewChild('focus',{static : false})
  tagPlateInputA1: ElementRef;

  @ViewChild('plateView',{static : false})
  plateViewCmp: PlateViewComponent;
  
  dirty = false;
  showFilter: boolean = true; 

  readonly buttonsRound= {"margin-bottom": "5px",
  "margin-top": "5px",
  "font-weight": "bold",
  "font-size": "14px",
  "padding": "7px",
  "width":"96%",
  "border-radius":"5px",
   "border-color": "#83b8e6",
   "background-color": "#83b8e6"
  }

  batches: Covid19Batch[] = [];
  selectedBatch: Covid19Batch;
  puid: string;
  batchToSearch: string;
  sampleToSearch: string;
  showBatch = false;
  errorHandler: ErrorHandler = new ErrorHandler;
  allowCreate: boolean = false;
  selectedLabId: string;
  mapOfStatusSaves = new Map();
  refStatusOfPrev: string;

  // table properties and values
  filterOptions: any[];
  selectedStates: string[] = [];
  blocked = false;
  loading: boolean;
  fromDate: Date;
  toDate: Date;
  mapOfSenders = new Map<string, any>();

  selectedLab: LabMDM;
  selectedSender: SenderDTO;
  selectableLab: SelectableLab;

  fieldBatchID:string = "BatchId";

  searchFilterList:any[];
  selectedSearchFilter:any;
  valueToSearch : string;


  posControlsForLab: number;
  negativeControlForLab: number;
  posControlsRemaining: number;
  negativeControlRemaining: number;
  totalPCRControls: number;
  scanDialogMessage: string;
  statusMerging_Defined:string;
  statusMerged_Completed:string;
  mapOfTags = new Map();
  mapOfTagsFromMDM = new Map();
  tags: any[] = [];
  tagsList : any[] = [];
  cachedTags: any[] = [];
  cachedTagsList : any[] = [];
  selectedTagPlateA1: string;
  selectedTagPlateA2: string;
  selectedTagPlateB1: string;
  selectedTagPlateB2: string;
  sourceBatchSamplesMap: Map<string, CovidSamples[]> = new Map();
  tagPlateBarcodeA1: string;
  tagPlateBarcodeA2: string;
  tagPlateBarcodeB1: string;
  tagPlateBarcodeB2: string;
  tagRunPlanningSequenceA1: string;
  tagRunPlanningSequenceA2: string;
  tagRunPlanningSequenceB1: string;
  tagRunPlanningSequenceB2: string;
  
  enteredPuid: string;
  enteredPassword: string;
  assignTagPlatePopup: boolean;
  batchHistory: any[] = [];
  groupedBatches: BatchGroup[] = [];
  batchHistoryId : string;
  inputPopup: boolean;
  inputPopUpEventType: string;
  enteredRunId: string;
  enteredLane: string;
  enteredProjectId: string;
  enteredSampleName: string;
  enteredLibraryId: string;
  commentPopup: boolean;
  listOfSampleForSorting:any[] = [];
  mergedSamples: Map<string,CovidSamples>=new Map();
  checkForTagPlateDuplicate: boolean=false;
  checkForTagPlateDuplicateOnChange: boolean=false;  
  showPlateView = false;
  plateViewMode = "MIDPLEX_PLATE_VIEW_MODE";
  deactivatePlateView = false;
  previewComment: Comment;
  showCommentDialog = false;
  commentsMap = new Map<string, Comment[]>();
  newComment: Comment;
  batchCommentVisibility: Map<string, boolean>;
  sourceBatchCommentsMap:Map<string, Comment[]> = new Map();
  sourceCommentsFlagIndicator: boolean = false;
  sourceBatchCommt:Comment[] = [];
  dateFormat: any;
  dateTimeFormat: string;

  constructor(private _messagesService: MessagesService, private apgTestingService: APGTestingService, 
    private masterDataService: MasterDataService,private midplexSampleService:MidplexSamplesService) { }

  getDropdownStyle(){
    let style = {
      'height': '100%',
      'font-weight': 'bold',
      'width': '95%',
    };
    if(this.showFilter)
      style['font-size'] = '90%';
    else
      style['font-size'] = '115%';
    return style;
  }
     
  setDateFormat(dateFormat){
    return   dateFormat.length>8  ? dateFormat.replace("yyyy","yy"): dateFormat.replace("yy","y");
  }

    ngOnInit() {
      this.statusMerging_Defined="Merge Defined";
      this.statusMerged_Completed="Merge Completed";
      this.selectedBatch = new Covid19Batch();
      this.showPlateView = false;
      this.selectedBatch.sender = '';
      this.selectableLab = JSON.parse(localStorage.getItem('lab'));
      this.dateTimeFormat = this.selectableLab.lab.dateTimeFormat;
      this.dateFormat =this.setDateFormat( this.selectableLab.lab.dateFormat.toLowerCase());
      this.selectedLabId = this.selectableLab.lab._id;
      this.puid = localStorage.getItem('PUID');
      this.populateSenders();
      this.loading = true;
      this.previewComment = new Comment();
      this.commentsMap = new Map<string, Comment[]>();
      this.newComment = new Comment();
      this.batchCommentVisibility = new Map<string, boolean>();
      this.midplexSampleService.getMidplexBatchesForLab(this.selectedLabId).subscribe(
        midplexresults => {
          this.loading = false;
          this.batches = midplexresults.data;
        },
        error => {
          this.handleError(error)
        }
      )
  
      this.searchFilterList = [
        {label:'Batch Id',value:'BatchId'},
        {label:'Sample Id',value:'SampleId'},
        {label:'External Id',value:'ExternalId'},
        {label:'Library Id',value:'LibraryId'}
      ];

      this.selectedSearchFilter = "BatchId"

      this.filterOptions = [
        { label: 'Upload Batch', value: "BATCH_UPLOADED" },
        { label: 'Receive Batch', value: "BATCH_RECEIVED" },
        { label: 'Controls Added', value: "CONTROLS_ADDED" },
        { label: 'Merge defined', value: "MERGE_DEFINED" },
        { label: 'Merge completed', value: "MERGE_COMPLETE" },
        { label: 'Merging', value: "MERGING" },
        { label: 'Merged', value: "MERGED" },
        { label: 'Start PCR', value: "START_PCR" },
        { label: 'Complete PCR', value: "COMPLETE_PCR" },
        { label: 'Start Pooling', value: "START_POOLING" },
        { label: 'Complete Pooling', value: "COMPLETE_POOLING" },
        { label: 'Start Tag PCR', value: "START_TAG_PCR" },
        { label: 'Complete Tag PCR', value: "COMPLETE_TAG_PCR" },
        { label: 'Start Lib Pooling', value: "START_LIB_POOLING" },
        { label: 'Complete Lib Pooling', value: "COMPLETE_LIB_POOLING" },
        { label: 'Start Purification', value: "START_PURIFICATION" },
        { label: 'Complete Purification', value: "COMPLETE_PURIFICATION" },
        { label: 'Start Lib QC', value: "START_LIB_QC" },
        { label: 'Complete Lib QC', value: "COMPLETE_LIB_QC" },
        { label: 'Transfer Sequencing', value: "TRANSFER_SEQUENCING" },
        { label: 'Start Sequencing', value: "START_SEQUENCING_RUN" },
        { label: 'Complete Sequencing', value: "COMPLETE_SEQUENCING_RUN" },
        { label: 'Start Data Review', value: "START_DATA_REVIEW" },
        { label: 'Complete Data Review', value: "COMPLETE_DATA_REVIEW" },
        { label: 'Delivered', value: "COMPLETED" },
        { label: 'Redo', value: "REDO" }
      ];

      this.mapOfStatusSaves.set("BATCH_UPLOADED", "uploadBatch");
      this.mapOfStatusSaves.set("BATCH_RECEIVED", "receiveBatch");
      this.mapOfStatusSaves.set("CONTROLS_ADDED", "controlsAdded");
      this.mapOfStatusSaves.set("MERGE_DEFINED", "mergeDefined");
      this.mapOfStatusSaves.set("MERGE_COMPLETE", "mergeCompleted");
      this.mapOfStatusSaves.set("START_PCR", "startPCR");
      this.mapOfStatusSaves.set("COMPLETE_PCR", "completePCR");
      this.mapOfStatusSaves.set("START_POOLING", "startPooling");
      this.mapOfStatusSaves.set("COMPLETE_POOLING", "completePooling");
      this.mapOfStatusSaves.set("START_TAG_PCR", "startTagPCR");
      this.mapOfStatusSaves.set("COMPLETE_TAG_PCR", "completeTagPCR");
      this.mapOfStatusSaves.set("TRANSFER_SEQUENCING", "transferSequencing");
      this.mapOfStatusSaves.set("START_SEQUENCING_RUN", "startSequencing");
      this.mapOfStatusSaves.set("COMPLETE_SEQUENCING_RUN", "completeSequencing");
      this.mapOfStatusSaves.set("START_PURIFICATION", "startPurification");
      this.mapOfStatusSaves.set("COMPLETE_PURIFICATION", "completePurification");
      this.mapOfStatusSaves.set("START_LIB_QC", "startLibQC");
      this.mapOfStatusSaves.set("COMPLETE_LIB_QC", "completeLibQC");
      this.mapOfStatusSaves.set("START_LIB_POOLING", "startLibPooling");
      this.mapOfStatusSaves.set("COMPLETE_LIB_POOLING", "completeLibPooling");
      this.mapOfStatusSaves.set("START_DATA_REVIEW", "startDataReview");
      this.mapOfStatusSaves.set("COMPLETE_DATA_REVIEW", "completeDataReview");
    }

    populateSenders() {
      this.masterDataService.getMapOfSenders(this.selectedLabId, true).subscribe(
        (result) => {
          if (result.data) {
            Object.entries(result.data).forEach(([key, value]) => {
              this.mapOfSenders.set(key, value);
            });
          }
        },
        (error) => {
          let message = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(message);
        }
      );
    }
    
    batchViewVisbility(event: any) {
      this.batchToSearch = event.data.batchID;
      this.sampleToSearch = '';
      this.searchForBatch();
      this.batchHistoryId=this.batchToSearch
    }
    searchBatch() {
      this.batchToSearch = this.batchHistoryId;
      this.searchForBatch();
    }

    searchForBatch() {
      if (this.batchToSearch == null || this.batchToSearch == undefined || this.batchToSearch.trim() === '') {
        this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Batch ID Empty', detail: 'Please enter Batch ID to search' });
        return;
      }
      this.searchForBatchAction(this.selectedLabId, this.batchToSearch.trim());
    }

  searchForBatchAction(labID: string, batchID: string) {
    this.blocked = true;
    this.batchHistoryId='';
    this.apgTestingService.getBatchForLabAndBatchId(labID, this.fieldBatchID, batchID).subscribe(
      result => {
        if (result.data) {
          this.selectedBatch = result.data;
          this.allowCreate = false;
          this.showPlateView = false;
          this.populateBatchHistory()
          this.getSourceBatches();
          this.selectedSender = this.mapOfSenders.get(this.selectedBatch.sender);
          this.getActiveTagPlatesFromMDM();
          this.commentsMap = new Map<string, Comment[]>();
          if(this.selectedBatch.wellType == 'WELL384'){
            this.getSourceBatchComment();
          }
          this.previewComment = this.getPreviewComment(this.selectedBatch);
        } else {
          this._messagesService.addErrorMessage({ severity: 'error', summary: 'Batch Not Found', detail: 'Batch not found with BatchID ' + this.batchToSearch });
          this.resetTagPlateDropdowns();
        }
        this.showBatch = true;
        this.blocked = false;
      },
      error => {
        this.handleError(error)
      }
    );
  }
  populateBatchHistory() {
    let sourceBatchIds = this.selectedBatch.wellType == 'WELL384' ? this.selectedBatch.sourceBatchIds.join(",") : '';
    this.apgTestingService.getBatchHistory(this.selectedBatch.lab, this.selectedBatch.batchID, this.selectedBatch.wellType, sourceBatchIds).subscribe(
      result => {
        this.batchHistory = [];
        this.groupedBatches = [];
        if (result.data) {
          if (this.selectedBatch.wellType == 'WELL384') {
            let groupLabel = '';
            Object.entries(result.data).forEach(([key]) => {
              let batchGroup = new BatchGroup();
              let batcheIds = result.data[key];
              batcheIds.forEach((element: string) => {
                if (this.selectedBatch.sourceBatchIds.includes(element)) {
                  groupLabel = element;
                }
              });
              batchGroup.label = groupLabel;
              result.data[key].forEach((element: string) => {
                let batchItems = new BatchItemHistory();
                batchItems.label = element;
                batchItems.value = element;
                batchGroup.items.push(batchItems);
              });
              this.groupedBatches.push(batchGroup);
            });

          } else {
            result.data.forEach(batch => {
              this.batchHistory.push({label: batch, value: batch});
            });
          }
        }
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }
historyResponse(result){
  result.data.forEach(batch => {
    this.batchHistory.push({label: batch, value: batch});
   
  });
}
  resetTagPlateDropdowns() {
    this.selectedTagPlateA1 = null;
    this.selectedTagPlateA2 = null;
    this.selectedTagPlateB1 = null;
    this.selectedTagPlateB2 = null;
  }
    private getSourceBatches() {
      if(this.selectedBatch.wellType === WellType.WELL384){
        this.deactivatePlateView = true;
        this.midplexSampleService.getSourceBatchSamples(this.selectedLabId, this.selectedBatch.sourceBatchIds.join(',')).subscribe(
          results=>{
            this.sourceBatchSamplesMap = new Map(Object.entries(results.data));
            this.deactivatePlateView = false;
          },
          error=>{
            let message = this.errorHandler.handleError(error);
            this._messagesService.addErrorMessage(message);
          }
        )
      }
    }

  
    getfunction(){
      if(this.selectedBatch.sender){
        if(this.selectedBatch.sender.length <= 21){
          return this.selectedBatch.sender
        }else if(this.selectedBatch.sender.length > 21){
          return this.selectedSender.senderShortName 
        }
      }
    }

    getSamplesCount(){
      if(this.selectedBatch.wellType==WellType.WELL384){
          return this.selectedBatch.sampleListSizeWithoutControls;
      }else{
        if(this.selectedBatch.samples){
          return this.selectedBatch.samples.length;
        }
      }
    }

    labelFunctionMergingDefined(){
      return WellType.WELL96==this.selectedBatch.wellType? 'Merging':'Merge Defined';
    }

    labelFunctionMergedCompleted(){
      return WellType.WELL96==this.selectedBatch.wellType? 'Merged':'Merge Completed';
    }

    onApplyFilter() {
      this.loading = true;
      if (this.selectedStates.length == 0 && !this.fromDate && !this.toDate) {
        this.midplexSampleService.getMidplexBatchesForLab(this.selectedLabId).subscribe(
          results => {  
            this.batches = results.data;
            this.loading = false;
          },
          error => {
            this.handleError(error)
          }
        )
      }
      else {
        let toFilterDate: Date;
        if (!this.fromDate && !this.toDate && this.selectedStates.some( ai => APGCovid19Constants.terminatingStates.includes(ai))) {
          this.toDate = new Date();
          this.fromDate = new Date();
          this.fromDate.setDate(this.toDate.getDate() - 14);
        }
        let selectedStatusList = this.getStatusList();
        if(this.toDate){
          toFilterDate = new Date(this.toDate.getTime());
          toFilterDate.setDate(toFilterDate.getDate() + 1)
        }
        this.midplexSampleService.filterMidplexBatchesForSamplesMenu(selectedStatusList, this.selectedLabId, !this.fromDate ? '' : this.fromDate.toDateString(), !this.toDate ? '' : toFilterDate.toDateString()).subscribe(
          results => {
            this.loading = false;
            this.batches = results.data;
          },
          filterError => {
            this.loading = false;
            let filtermessage = this.errorHandler.handleError(filterError);
            this._messagesService.addErrorMessage(filtermessage);
          }
        )
      }
    }

    private getStatusList() {
      if (this.selectedStates && this.selectedStates.length != 0)
        return this.selectedStates.join(",");
      else {
        let nonTerminatingStates = [];
        this.filterOptions.forEach(option => {
          if (!APGCovid19Constants.terminatingStates.includes(option.value))
            nonTerminatingStates.push(option.value);
        });
        return nonTerminatingStates.join(",");
      }
    }
  
  searchForBatchWIthFilter() {
    if (!this.valueToSearch || this.valueToSearch.trim() == '') {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Value Not Entered', detail: 'Please Enter the value to search.' });
      return;
    }
    this.blocked = true;
    this.apgTestingService.getBatchForLabAndBatchId(this.selectedLabId, this.selectedSearchFilter, this.valueToSearch.trim()).subscribe(
      result => {
        this.batchHistoryId=this.valueToSearch
        if (result && result.data != null) {
          this.selectedBatch = result.data;
          this.populateBatchHistory();
          this.previewComment = this.getPreviewComment(this.selectedBatch);
          this.commentsMap = new Map<string, Comment[]>();
          if(this.selectedBatch.wellType == 'WELL384'){
            this.getSourceBatchComment();
          }
          this.showPlateView = false;
          if (this.selectedBatch.workflowGroup == null || this.selectedBatch.workflowGroup != "Midplex") {
            this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Artic Batch found!', detail: 'Batch ' + this.selectedBatch.batchID + ' is a Artic batch that can not be processed on this page' });
          } 
            this.getSourceBatches();
            this.showMessageForSearchBatch();
            this.valueToSearch = '';
            this.selectedSender = this.mapOfSenders.get(this.selectedBatch.sender);
            this.getActiveTagPlatesFromMDM();
        } else {
            this._messagesService.addErrorMessage({ severity: 'error', summary: 'Batch Not Found', detail: 'Batch not found with '+this.selectedSearchFilter +' '+ this.valueToSearch.trim() });         
        }
        this.blocked = false;
      },
      error => {
        this.handleError(error);
      });
  }

  private handleError(error: any) {
    this.blocked = false;
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }

    enableIfStatusIn(status: string[]){
      return !status.includes(this.selectedBatch.statusOfTheBatch);
    }

    enableIfStatusInForPool(status: string[]){
      return !status.includes(this.selectedBatch.statusOfTheBatch) || this.selectedBatch.nglimsSampleCreationDateTime;
    }

    disableReceiveBatch() {
      return !(this.selectedBatch.excelUploadCreatedAt && this.selectedBatch.excelUploadCreatedBy && this.selectedBatch.workflowGroup=='Midplex');
    }

    disableControlsAdded(){
      return !(this.selectedBatch.batchReceivedDateTime && this.selectedBatch.batchReceivedPUID && this.selectedBatch.workflowGroup=='Midplex')
    }

    disableStartPCR(){
      return !(this.selectedBatch.mergeCompleteDateTime && this.selectedBatch.mergeCompletePUID)
    }

    disableCompletePCR(){
      return !(this.selectedBatch.startPcrDateTime && this.selectedBatch.startPcrPUID)
    }

    disableStartPooling(){
      return !(this.selectedBatch.completePcrDateTime && this.selectedBatch.completePcrPUID)
    }

    completStartPooling(){
      return !(this.selectedBatch.startPoolingDateTime && this.selectedBatch.startPoolingPUID)
    }

    disableStartTagPCR(){
      return !(this.selectedBatch.completePoolingDateTime && this.selectedBatch.completePoolingPUID)
    }

    disableAssignTagPlate(){
      return !(this.selectedBatch.startTagPCRDateTime && this.selectedBatch.startTagPCRPUID && this.checkIfAllTagPlatesSelected())   
    }

    assignButtonDisabled(){
      return !(this.enteredPuid && this.enteredPassword && this.checkIfAllValidQuadrantsHaveTagPlateBarcode())
    }

    disableCompleteTagPCR(){
      return !(this.selectedBatch.assignTagPlateDateTime && this.selectedBatch.assignTagPlatePUID)
    }

    disableStartPurification(){
      return !(this.selectedBatch.completeLibPoolingDateTime && this.selectedBatch.completeLibPoolingPUID) 
    }

    disableCompletePurification(){
      return !(this.selectedBatch.startPurificationDateTime && this.selectedBatch.startPurificationPUID) 
    }

    disableStartLibQC(){
      return !(this.selectedBatch.completePurificationDateTime && this.selectedBatch.completePurificationPUID) 
    }

    disableCompleteLibQC(){
      return !(this.selectedBatch.startLibQCDateTime && this.selectedBatch.startLibQCPUID) 
    }

    disableStartLibPooling(){
      return !(this.selectedBatch.completeTagPCRDateTime && this.selectedBatch.completeTagPCRPUID) 
    }

    disableCompleteLibPooling(){
      return !(this.selectedBatch.startLibPoolingDateTime && this.selectedBatch.startLibPoolingPUID) 
    }

    disableTransferSequencing(){
      return !(this.selectedBatch.completeLibQCDateTime && this.selectedBatch.completeLibQCPUID)  
    }

    disableStartSequencing(){
      return !(this.selectedBatch.transferSequencingDateTime && this.selectedBatch.transferSequencingPUID)  
    }

    disableCompleteRun(){
      return !(this.selectedBatch.startSequencingDateTime && this.selectedBatch.startSequencingPUID)  
    }
    
    disableTagSortingFile(){
      return (this.selectedBatch.snpResultUploadDateTime && this.selectedBatch.snpResultUploadPUID) 
    }
    disableStartDataReview(){
      return !(this.selectedBatch.snpResultUploadDateTime && this.selectedBatch.snpResultUploadPUID)  
    }

    disableCompleteDataReview(){
      return !(this.selectedBatch.startDataReviewDateTime && this.selectedBatch.startDataReviewPUID)  
    }

  checkIfAllValidQuadrantsHaveTagPlateBarcode() {
    let allValidTagPlateBarcodesAvailable = true;
    if (this.selectedBatch.mergedBatches[0] && !this.tagPlateBarcodeA1)
      allValidTagPlateBarcodesAvailable = false;
    if (this.selectedBatch.mergedBatches[1] && !this.tagPlateBarcodeA2)
      allValidTagPlateBarcodesAvailable = false;
    if (this.selectedBatch.mergedBatches[2] && !this.tagPlateBarcodeB1)
      allValidTagPlateBarcodesAvailable = false;
    if (this.selectedBatch.mergedBatches[3] && !this.tagPlateBarcodeB2)
      allValidTagPlateBarcodesAvailable = false;
    return allValidTagPlateBarcodesAvailable;
  }


    saveBatchStatus(status: string) {
      if (this.selectedBatch.batchID == null || this.selectedBatch.batchID == undefined || this.selectedBatch.batchID == '') {
        this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Batch ID Empty', detail: 'Please enter Batch ID to save' });
        return;
      }
      if (!this.isPUIDPresnt()) {
        this._messagesService.addWarningMessage({ severity: 'warn', summary: 'User ID Empty', detail: 'Please enter User ID to save' });
        return;
      }
      this.saveBatchStatusAction(status);
    }
  
    saveBatchStatusAction(status: string) {
      let functionName = this.mapOfStatusSaves.get(status);
      this[functionName](status);
    }

    uploadBatch(status: string){
      this.selectedBatch.batchUploadedDateTime = new Date();
      this.selectedBatch.batchUploadedPUID = this.puid;
      this.updateBatch(status);
    }
    receiveBatch(status: string){
      this.selectedBatch.batchReceivedDateTime = new Date();
      this.selectedBatch.batchReceivedPUID = this.puid;
      this.selectedBatch.filterDateTime = new Date();
      this.selectedBatch.deliveryTargetDateTime = this.addBusinessDays(this.selectedBatch.batchReceivedDateTime, 7);
      this.updateBatch(status);
    }

    startPCR(status: string){
      this.selectedBatch.startPcrDateTime = new Date();
      this.selectedBatch.startPcrPUID= this.puid;
      this.updateBatch(status);
    }

    completePCR(status: string){
      this.selectedBatch.completePcrDateTime = new Date();
      this.selectedBatch.completePcrPUID= this.puid;
      this.updateBatch(status);
    }

    startPooling(status: string){
      this.selectedBatch.startPoolingDateTime = new Date();
      this.selectedBatch.startPoolingPUID= this.puid;
      this.updateBatch(status);
    }

    completePooling(status: string){
      this.selectedBatch.completePoolingDateTime = new Date();
      this.selectedBatch.completePoolingPUID= this.puid;
      this.updateBatch(status);
    }

    controlsAdded(status: string){
      let lastSample = this.selectedBatch.samples.slice(-1).pop();
      if (!(lastSample.positionRow == 8 && lastSample.prositionCol == 12)) {
        let ntcControl = new CovidSamples();
        ntcControl.barcode = 'KON00_'+this.selectedBatch.batchID + '_NTC';
        ntcControl.positionRow = 7;
        ntcControl.prositionCol = 12;
        let pcControl = new CovidSamples();
        pcControl.barcode = 'KON00_'+this.selectedBatch.batchID + '_PC';
        pcControl.positionRow = 8;
        pcControl.prositionCol = 12;
        this.selectedBatch.samples.push(ntcControl);
        this.selectedBatch.samples.push(pcControl);
      }
      this.selectedBatch.controlsAddedDateTime = new Date();
      this.selectedBatch.controlsAddedPUID = this.puid;
      this.updateBatch(status);
    }

    startTagPCR(status: string){
      this.selectedBatch.startTagPCRDateTime = new Date();
      this.selectedBatch.startTagPCRPUID = this.puid;
      this.updateBatch(status);
    }
    completeTagPCR(status: string){
      this.selectedBatch.completeTagPCRDateTime = new Date();
      this.selectedBatch.completeTagPCRPUID = this.puid;
      this.updateBatch(status);
    }
    transferSequencing(status: string){
      this.selectedBatch.transferSequencingDateTime = new Date();
      this.selectedBatch.transferSequencingPUID = this.puid;
      this.updateBatch(status);
    }
    startSequencing(status: string){
      this.selectedBatch.startSequencingDateTime = new Date();
      this.selectedBatch.startSequencingPUID = this.puid;
      this.updateBatch(status);
    }
    completeSequencing(status: string){
      this.selectedBatch.completedSequencingDateTime = new Date();
      this.selectedBatch.completedSequencingPUID = this.puid;
      this.updateBatch(status);
    }
    startLibQC(status: string){
      this.selectedBatch.startLibQCDateTime = new Date();
      this.selectedBatch.startLibQCPUID = this.puid;
      this.updateBatch(status);
    }
    completeLibQC(status: string){
      this.selectedBatch.completeLibQCDateTime = new Date();
      this.selectedBatch.completeLibQCPUID = this.puid;
      this.updateBatch(status);
    }
    startPurification(status: string){
      this.selectedBatch.startPurificationDateTime = new Date();
      this.selectedBatch.startPurificationPUID = this.puid;
      this.updateBatch(status);
    }
    completePurification(status: string){
      this.selectedBatch.completePurificationDateTime = new Date();
      this.selectedBatch.completePurificationPUID = this.puid;
      this.updateBatch(status);
    }

    startLibPooling(status: string){
      this.selectedBatch.startLibPoolingDateTime = new Date();
      this.selectedBatch.startLibPoolingPUID = this.puid;
      this.updateBatch(status);
    }

    completeLibPooling(status: string){
      this.selectedBatch.completeLibPoolingDateTime = new Date();
      this.selectedBatch.completeLibPoolingPUID = this.puid;
      this.updateBatch(status);
    }

    startDataReview(status: string){
      this.selectedBatch.startDataReviewDateTime = new Date();
      this.selectedBatch.startDataReviewPUID = this.puid;
      this.updateBatch(status);
    }

    completeDataReview(status:string){
      this.selectedBatch.readyForDeliveryDateTime = new Date();
      this.selectedBatch.readyForDeliveryPUID = this.puid;
      this.setMergedBatches('QC OK');
      this.updateBatch(status);
      this.commentPopup = false;
    }

    updateBatch(statusOfBatch: string) {
      this.refStatusOfPrev = this.selectedBatch.previousStatusOfTheBatch;
      this.selectedBatch.statusOfTheBatch = statusOfBatch;
      this.selectedBatch.previousStatusOfTheBatch = statusOfBatch;
      this.saveBatchData();
    }

    
  isPUIDPresnt() {
    if (this.puid != null && this.puid != undefined && this.puid != '') {
      return true;
    }
    return false;
  }

  addBusinessDays(d:Date, n:number) {
    d = new Date(d.getTime());
    var day = d.getDay();
    d.setDate(d.getDate() + n + (day === 6 ? 2 : +!day) + (Math.floor((n - 1 + (day % 6 || 1)) / 5) * 2));
    return d;
  }

  saveBatchData() {
    this.blocked = true;
    this.selectedBatch.lab = this.selectedLabId;
    this.selectedBatch.userID = this.puid;  
    if(this.selectedBatch.statusOfTheBatch=='COMPLETE_DATA_REVIEW'){
      this.getAllMergedSamples();
      let sourceJsonMap = {};
      this.mergedSamples.forEach((V, K) => {
        sourceJsonMap[K] = V;
      });
      this.selectedBatch.labName=this.selectableLab.lab.name;
      this.selectedBatch.midplexMergedSamples=sourceJsonMap;
    }
    this.midplexSampleService.saveSampleMidplexData(this.selectedBatch).subscribe(
      result => {
        if (result.data) {
          this.selectedBatch = result.data;
          if (this.selectedBatch.statusOfTheBatch === "START_TAG_PCR" && this.selectedBatch.mergedBatches && !this.selectedBatch.mergedBatches[0].tagPlateBarcode) {
            this.assignTagPlates();
            this.checkTagPlatesDuplicates(null,'initialLoad');
          }
          if(!this.checkForTagPlateDuplicateOnChange){
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Batch Updated!',
            detail: 'Batch ' + this.selectedBatch.batchID + ' has been updated successfully'
          });
        }}
        this.blocked = false;
      },
      error => {
        this.blocked = false;
        this.selectedBatch.statusOfTheBatch = this.refStatusOfPrev;
        this.selectedBatch.previousStatusOfTheBatch = this.refStatusOfPrev;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }
  private assignTagPlates() {
    let indexOfLastTagPlateId = this.tagsList.indexOf(this.selectedBatch.lastUsedTagPlateId);
    if (indexOfLastTagPlateId == -1) {

      let cacheListForTest = [...this.tagsList];
      cacheListForTest.push(this.selectedBatch.lastUsedTagPlateId);
      cacheListForTest.sort();
      let returnObj = {};
      let indexOfLastTagPlateIdCheck = cacheListForTest.indexOf(this.selectedBatch.lastUsedTagPlateId);
      cacheListForTest.splice(indexOfLastTagPlateIdCheck, 1);
      returnObj = this.setTagPlateId(cacheListForTest, indexOfLastTagPlateIdCheck - 1, this.selectedTagPlateA1);
      this.selectedTagPlateA1 = returnObj['tagPlate'];
      if (this.selectedBatch.mergedBatches[1]) {
        returnObj = this.setTagPlateId(cacheListForTest, returnObj['index'], this.selectedTagPlateA2);
        this.selectedTagPlateA2 = returnObj['tagPlate'];
      }

      if (this.selectedBatch.mergedBatches[2]) {
        returnObj = this.setTagPlateId(cacheListForTest, returnObj['index'], this.selectedTagPlateB1);
        this.selectedTagPlateB1 = returnObj['tagPlate'];
      }

      if (this.selectedBatch.mergedBatches[3]) {
        returnObj = this.setTagPlateId(cacheListForTest, returnObj['index'], this.selectedTagPlateB2);
        this.selectedTagPlateB2 = returnObj['tagPlate'];
      }
    } else {
      let returnObj = {};
      returnObj = this.setTagPlateId(this.tagsList, indexOfLastTagPlateId, this.selectedTagPlateA1);
      this.selectedTagPlateA1 = returnObj['tagPlate'];

      if (this.selectedBatch.mergedBatches[1]) {
        returnObj = this.setTagPlateId(this.tagsList, returnObj['index'], this.selectedTagPlateA2);
        this.selectedTagPlateA2 = returnObj['tagPlate'];
      }

      if (this.selectedBatch.mergedBatches[2]) {
        returnObj = this.setTagPlateId(this.tagsList, returnObj['index'], this.selectedTagPlateB1);
        this.selectedTagPlateB1 = returnObj['tagPlate'];
      }

      if (this.selectedBatch.mergedBatches[3]) {
        returnObj = this.setTagPlateId(this.tagsList, returnObj['index'], this.selectedTagPlateB2);
        this.selectedTagPlateB2 = returnObj['tagPlate'];
      }
    }
  }

  setTagPlateId(tagPlateArr: any[], index: number, tagPlateToSet: string) {
    if (index + 1 == tagPlateArr.length) {
      tagPlateToSet = tagPlateArr[0];
      index = 0;
    } else {
      tagPlateToSet = tagPlateArr[index + 1];
      index++;
    }
    return {'index':index, 'tagPlate': tagPlateToSet};
  }

  showMessageForSearchBatch(): any {
    if(this.selectedBatch.matchedBatchCount == 1){
      this._messagesService.addSuccessMessage({
        severity: 'success', summary: 'Batch Found!',
        detail: 'Batch for ' + this.valueToSearch + ' is Found.'});
    }else if([2,3,4,5].includes(this.selectedBatch.matchedBatchCount)){
      this._messagesService.addWarningMessage({ 
      severity: 'warn',
      summary: 'Multiple Batchs Found', 
      detail: 'Showing Latest Batch. No. of Batchs found for given filter is: '+this.selectedBatch.matchedBatchCount+' Batch Id\'s are : '
      +this.selectedBatch.matchedBatchIDs});
    }else if(this.selectedBatch.matchedBatchCount>1) { 
      this._messagesService.addWarningMessage({ 
        severity: 'warn',
        summary: 'Multiple Batchs Found', 
        detail: 'Showing Latest Batch. No. of Batchs found for given filter is: '+this.selectedBatch.matchedBatchCount}); 
    }
  }

  getActiveTagPlatesFromMDM() {
    this.masterDataService.getMapOfTagsFromMDM(this.selectedLabId, this.selectedBatch.tagSystemName).subscribe(
      (result) => {
        if (result.data) {
          this.mapOfTagsFromMDM = new Map(Object.entries(result.data))
        }
        this.populateTags();
        
      },
      (error) => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  populateTags() {

    this.masterDataService.getMapOfTags(this.selectedLabId, this.selectedBatch.tagSystemName).subscribe(
      (result) => {
        if (result.data) {
          this.cachedTags = [];
          this.cachedTagsList = [];
          this.mapOfTags.clear();
          Object.entries(result.data).forEach(([key, value]) => {
            this.mapOfTags.set(key, value);
            if (this.mapOfTagsFromMDM.has(key)) {
              this.cachedTags.push({ label: key, value: key });
              this.cachedTagsList.push(key);
            }
            this.tags = [...this.cachedTags];
            this.tagsList = [...this.cachedTagsList];
            if (this.selectedBatch.wellType == 'WELL384') {
              if (this.selectedBatch.statusOfTheBatch === 'START_TAG_PCR' && !this.selectedBatch.mergedBatches[0].tagPlateBarcode) {
                this.assignTagPlates();
              } else {
                this.setTagPlateDropdowns();
              }
            } else {
              this.resetTagPlateDropdowns();
            }
          });
          this.checkTagPlatesDuplicates(null,'initialLoad')
        }
      },
      (error) => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  private setTagPlateDropdowns() {
    let tagPlate = this.selectedBatch.mergedBatches[0].tagPlateId;
    this.selectedTagPlateA1 = tagPlate;
    this.addTagPlateToTagList(tagPlate);
    if (this.selectedBatch.mergedBatches[1]) {
      tagPlate = this.selectedBatch.mergedBatches[1].tagPlateId;
      this.selectedTagPlateA2 = tagPlate;
      this.addTagPlateToTagList(tagPlate);
    } else {
      this.selectedTagPlateA2 = null;
    }

    if (this.selectedBatch.mergedBatches[2]) {
      tagPlate = this.selectedBatch.mergedBatches[2].tagPlateId;
      this.selectedTagPlateB1 = tagPlate;
      this.addTagPlateToTagList(tagPlate);
    } else {
      this.selectedTagPlateB1 = null;
    }
    if (this.selectedBatch.mergedBatches[3]) {
      tagPlate = this.selectedBatch.mergedBatches[3].tagPlateId;
      this.selectedTagPlateB2 = tagPlate;
      this.addTagPlateToTagList(tagPlate);
    } else {
      this.selectedTagPlateB2 = null;
    }
  }

  private addTagPlateToTagList(tagPlate: string) {
    if (tagPlate && !this.mapOfTagsFromMDM.has(tagPlate)) {
      this.tags.push({ label: tagPlate, value: tagPlate });
      this.tagsList.push(tagPlate);
    }
  }

  openAssignTagPlatePopup(){
    this.enteredPuid = '';
    this.enteredPassword = '';
    this.tagPlateBarcodeA1 = this.tagPlateBarcodeA2 = this.tagPlateBarcodeB1 = this.tagPlateBarcodeB2 = '';
    setTimeout(() => {
      this.tagPlateInputA1.nativeElement.focus();
    }, 1000);
    this.assignTagPlatePopup = true;
  }

  assignTagPlateBarcodes(){
    if(!this.enteredPuid || !this.enteredPassword){
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Insufficient Login Details!',
        detail: 'Please enter valid Email & Password'
      });
      return;
    }

    let puidFromPopup = this.enteredPuid.substring(0,this.enteredPuid.indexOf('@'));
    if ((puidFromPopup.toLowerCase() != this.puid.toLowerCase())) {
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Verification Failed!',
        detail: 'Username should be same as Logged in user',
      });
      return;
    }

    if(!this.checkIfAllValidQuadrantsHaveTagPlateBarcode()){
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Insuffiecient Information!',
        detail: 'All Tag Plate Barcodes are not Entered, Please Fill All the Tag Plate Barcodes & Press Assign.',
      });
      return;
    }

    //check if selected tag plate is valid. If yes, then validate tag plate barcode from MDM data for each quadrant.
    if(!this.validateQuadrantTagPlate(this.selectedTagPlateA1, this.tagPlateBarcodeA1 , "A1")){
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Invalid Tag Plate!',
        detail: 'Selected Tag Plate or Barcode For Quadrant A1 Not configured in MDM.',
      });
      return;
    }

    if(this.selectedBatch.mergedBatches[1] && !this.validateQuadrantTagPlate(this.selectedTagPlateA2, this.tagPlateBarcodeA2, "A2")){
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Invalid Tag Plate!',
        detail: 'Selected Tag Plate or Barcode For Quadrant A2 Not configured in MDM.',
      });
      return;
    }

    if(this.selectedBatch.mergedBatches[2] && !this.validateQuadrantTagPlate(this.selectedTagPlateB1, this.tagPlateBarcodeB1,"B1")){
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Invalid Tag Plate!',
        detail: 'Selected Tag Plate or Barcode For Quadrant B1 Not configured in MDM.',
      });
      return;
    }

    if(this.selectedBatch.mergedBatches[3] && !this.validateQuadrantTagPlate(this.selectedTagPlateB2, this.tagPlateBarcodeB2,"B2")){
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Invalid Tag Plate!',
        detail: 'Selected Tag Plate or Barcode For Quadrant B2 Not configured in MDM.',
      });
      return;
    }

    let sampleUpdateString  = '{';
    this.selectedBatch.sampleUpdate = {};
    sampleUpdateString = this.setSampleUpdateString(sampleUpdateString, 0, this.selectedTagPlateA1);
    this.selectedBatch.mergedBatches[0].tagPlateId = this.selectedTagPlateA1;
    this.selectedBatch.mergedBatches[0].tagPlateBarcode = this.tagPlateBarcodeA1;
    this.selectedBatch.mergedBatches[0].tagRunPlanningSequence = this.tagRunPlanningSequenceA1;

  
    this.selectedBatch.sampleUpdate[this.selectedBatch.mergedBatches[0].batchId] = sampleUpdateString;

    if(this.selectedBatch.mergedBatches[1]){
      sampleUpdateString  = '{';
      sampleUpdateString = this.setSampleUpdateString(sampleUpdateString, 1, this.selectedTagPlateA2);
      this.selectedBatch.mergedBatches[1].tagPlateId = this.selectedTagPlateA2;
      this.selectedBatch.mergedBatches[1].tagPlateBarcode = this.tagPlateBarcodeA2;
      this.selectedBatch.sampleUpdate[this.selectedBatch.mergedBatches[1].batchId] = sampleUpdateString;
      this.selectedBatch.mergedBatches[1].tagRunPlanningSequence = this.tagRunPlanningSequenceA2;
    }

    if(this.selectedBatch.mergedBatches[2]){
      sampleUpdateString  = '{';
      sampleUpdateString = this.setSampleUpdateString(sampleUpdateString, 2, this.selectedTagPlateB1);
      this.selectedBatch.mergedBatches[2].tagPlateId = this.selectedTagPlateB1;
      this.selectedBatch.mergedBatches[2].tagPlateBarcode = this.tagPlateBarcodeB1;
      this.selectedBatch.mergedBatches[2].tagRunPlanningSequence = this.tagRunPlanningSequenceB1;
      this.selectedBatch.sampleUpdate[this.selectedBatch.mergedBatches[2].batchId] = sampleUpdateString;
    }

    if(this.selectedBatch.mergedBatches[3]){
      sampleUpdateString  = '{';
      sampleUpdateString = this.setSampleUpdateString(sampleUpdateString, 3, this.selectedTagPlateB2);
      this.selectedBatch.mergedBatches[3].tagPlateId = this.selectedTagPlateB2;
      this.selectedBatch.mergedBatches[3].tagPlateBarcode = this.tagPlateBarcodeB2;
      this.selectedBatch.mergedBatches[3].tagRunPlanningSequence = this.tagRunPlanningSequenceB2;
      this.selectedBatch.sampleUpdate[this.selectedBatch.mergedBatches[3].batchId] = sampleUpdateString;
    }

    this.selectedBatch.assignTagPlateDateTime = new Date();
    this.selectedBatch.assignTagPlatePUID = puidFromPopup;
    this.selectedBatch.username = this.enteredPuid;
    this.selectedBatch.password = this.convertStringToUTF8ByteArray(this.enteredPassword);
    this.blocked = true;
    this.midplexSampleService.assignTagPlateBarcodes(this.selectedBatch).subscribe(
      results=>{
        this.selectedBatch = results.data;
        this.assignTagPlatePopup = false;
        this.getSourceBatches();
        this._messagesService.addSuccessMessage({
          severity:'success', summary:'Tag Plates Assigned!!',
          detail:'Tag Plates with barcodes assigned for all Quadrants.'
        })
        this.blocked = false;
      },
      error=>{
        this.blocked = false;
        this.enteredPuid = null;
        this.enteredPassword = null;
        this.selectedBatch.assignTagPlateDateTime = null;
        this.selectedBatch.assignTagPlatePUID = null;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    )
  }
  private setSampleUpdateString(sampleUpdateString: string, indexOfMergedbatches: number, tagPlateSelected: string) {
    let samples = this.sourceBatchSamplesMap.get(this.selectedBatch.mergedBatches[indexOfMergedbatches].batchId);
    let tagPlate = this.mapOfTags.get(tagPlateSelected);
    let samplesSize = samples.length;
    let i: number = 0;
    samples.forEach(sample => {
      let position = this.getSamplePositionString(sample);
      let tag = tagPlate[position];
      sampleUpdateString = sampleUpdateString + '"samples.' + sample.index + '.tagPlateId":"' + tagPlateSelected +
        '", "samples.' + sample.index + '.u7Sequence":"' + tag.u7Sequence + '", "samples.' + sample.index
        + '.u5Sequence":"' + tag.u5Sequence + '"';
      if (i < (samplesSize - 1))
        sampleUpdateString += ',';
      i++;
    });
    sampleUpdateString += '}';
    return sampleUpdateString;
  }

  validateQuadrantTagPlate(tagPlate: string, tagPlateBarcode: string, quadrant: string) {
    if (!this.mapOfTagsFromMDM.has(tagPlate))
      return false;
    else {
      let tagObj = this.mapOfTagsFromMDM.get(tagPlate);
      let tag = tagObj.tagPlateBarcode;
      this["tagRunPlanningSequence"+quadrant]= tagObj.runPlanningSequence;     
      return tag.includes(tagPlateBarcode);
    }
  }

  resetTagPlateBarcodeInputs(){
    this.tagPlateBarcodeA1 = null;
    this.tagPlateBarcodeA2 = null;
    this.tagPlateBarcodeB1 = null;
    this.tagPlateBarcodeB2 = null;
    this.enteredPassword = null;
    this.enteredPuid = null;
  }
  private getSamplePositionString(sample: CovidSamples){
    let position = String.fromCharCode(64 + sample.positionRow96);
    if(sample.positionCol96 < 10)
      position += '0';
    position += sample.positionCol96;
    return position;
  }

  private convertStringToUTF8ByteArray(str) {
    var data = [];
    for (var i = 0; i < str.length; i++) {
      data.push(str.charCodeAt(i));
    }
    return data;
  }

  private checkIfAllTagPlatesSelected() {

    let allValidTagPlatesAvailable = true;
    if (this.selectedBatch.wellType == 'WELL384') {
      if (this.selectedBatch.mergedBatches[0] && !this.selectedTagPlateA1)
        allValidTagPlatesAvailable = false;
      if (this.selectedBatch.mergedBatches[1] && !this.selectedTagPlateA2)
        allValidTagPlatesAvailable = false;
      if (this.selectedBatch.mergedBatches[2] && !this.selectedTagPlateB1)
        allValidTagPlatesAvailable = false;
      if (this.selectedBatch.mergedBatches[3] && !this.selectedTagPlateB2)
        allValidTagPlatesAvailable = false;
    }
    return allValidTagPlatesAvailable;
  }
  searchButtonDisabledIf(){
    return !(this.selectedSearchFilter && this.valueToSearch && this.valueToSearch.trim() != '' );
  }

  getFileUploadStyle() {
    return {
      'margin-bottom': '5px',
      'margin-top': '5px',
      'font-weight': 'bold',
      'font-size': '14px',
      'padding': '7px 0px 7px 0px',
      'width': '96%',
      'border-radius': '5px',
      'background-color': '#0072bc',
      'border': 'none',
      'box-shadow': '0 .125rem .25rem rgba(0,0,0,.075)'
    }
  }

  onFileSelect(event){
    if(event.files[0].name.split('.').pop() != "tsv"){
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Invalid File Type!!',
        detail: 'Only TSV files are allowed.',
      });
    }
  }

  onCSVUpload(event, fileUploader: any){
    const formData = new FormData();
    let requestJson = {};
    requestJson['labId'] = this.selectedLabId;
    requestJson['batchID'] = this.selectedBatch.batchID;
    requestJson['puid'] = this.puid;
    requestJson['product'] = this.selectedBatch.product;
    requestJson['sourceBatchIds'] = this.selectedBatch.sourceBatchIds;
    let requestData = JSON.stringify(requestJson);
    formData.append("requestData", requestData);
    formData.append("uploadType", "SNPResult_upload");
    formData.append("file",event.files[0]);
    this.blocked = true;
    this.midplexSampleService.uploadCSVFile(formData).subscribe(
      result => {
        if (!result) {
          return;
        }
        fileUploader.clear();
        this.selectedBatch = result.data;
        this.blocked = false;
        this.getSourceBatches();
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Upload Successful!', detail: 'TSV file has been uploaded successfully' });
      },
      error => {
        fileUploader.clear();
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    )
  }

  showInputNGLIMSDataPopup(event){
    if(this.selectedBatch.workflowGroup == null || this.selectedBatch.workflowGroup !='Midplex'){
     return this._messagesService.addErrorMessage({
        severity:'error', summary:'Invalid Operation!',
        detail: 'Modifying NGLIMS Information is only allowed for Midplex batches.'
      });
    }
    if(this.enableIfStatusInForPool(['COMPLETE_TAG_PCR','START_LIB_POOLING','COMPLETE_LIB_POOLING','START_PURIFICATION','START_LIB_QC', 'COMPLETE_PURIFICATION'])){
      this._messagesService.addErrorMessage({
        severity:'error', summary:'Invalid Operation!',
        detail: 'Modifying NGLIMS Information is not allowed at this stage.'
      });
    }
    else{
      this.enteredProjectId = this.selectedBatch.nglimsProjectId;
      this.enteredSampleName = this.selectedBatch.nglimsSampleId;
      this.enteredLibraryId = this.selectedBatch.libraryId;
      this.inputPopUpEventType = event.type;
      this.inputPopup = true;
    }
  }

  clearNGLIMSInputFields(){
    this.inputPopUpEventType = null;
    this.enteredRunId = null;
    this.enteredLane = null;
    this.enteredProjectId = null;
    this.enteredLibraryId = null;
    this.enteredSampleName = null;
  }

  saveBatchOnStartLibQC(){
    if(!this.selectedBatch.nglimsProjectId && !this.selectedBatch.nglimsSampleId && !this.selectedBatch.libraryId){
      this.inputPopUpEventType = 'status';
      this.inputPopup = true;
    } else{
      this.saveBatchStatus('START_LIB_QC');
    }
  }

  showPopUpForRunLane(){
    if(this.selectedBatch.runAndLaneIdInfo && this.selectedBatch.runAndLaneIdInfo.length > 0){
      this.enteredRunId = this.selectedBatch.runAndLaneIdInfo[0].runId;
      this.enteredLane = this.selectedBatch.runAndLaneIdInfo[0].laneId;
    }
    this.inputPopUpEventType = 'status';
    this.inputPopup = true;
  }

  saveNGLIMSInfo(){
    if(this.inputPopUpEventType == 'click'){
      this.selectedBatch.nglimsProjectId = this.enteredProjectId;
      this.selectedBatch.nglimsSampleId = this.enteredSampleName;
      this.selectedBatch.libraryId = this.enteredLibraryId;
      this.saveBatchData()
    } else if(this.selectedBatch.statusOfTheBatch == 'COMPLETE_PURIFICATION' || this.selectedBatch.statusOfTheBatch == 'START_LIB_QC'){
      this.selectedBatch.nglimsProjectId = this.enteredProjectId;
      this.selectedBatch.nglimsSampleId = this.enteredSampleName;
      this.selectedBatch.libraryId = this.enteredLibraryId;
      this.startLibQC('START_LIB_QC');
    } else{
      this.selectedBatch.runAndLaneIdInfo = [];
      let runLane : RunLane = new RunLane;
      runLane.runId = this.enteredRunId;
      runLane.laneId = this.enteredLane;
      this.selectedBatch.runAndLaneIdInfo.push(runLane);
      this.startSequencing('START_SEQUENCING_RUN');
    }
    this.inputPopup = false;
  }

  saveNGLIMSButtonDisabledIf(){
    if(!this.enableIfStatusIn(['TRANSFER_SEQUENCING','START_SEQUENCING_RUN']))
      return !(this.enteredRunId && this.enteredLane)
    else
      return !(this.enteredProjectId && this.enteredSampleName && this.enteredLibraryId)
  }
  createTagSortingFile(){
    this.listOfSampleForSorting = [];
    this.selectedBatch.sourceBatchIds.forEach(result => {
      this.sourceBatchSamplesMap.get(result).forEach(data => {
        this.listOfSampleForSorting.push(data)
      });
    });
   
    const formData = new FormData();
    let requestJson = {};
    requestJson['runAndLandId'] = this.selectedBatch.runAndLaneIdInfo;
    requestJson['batchID'] = this.selectedBatch.batchID;
    requestJson['dataList']= this.listOfSampleForSorting;
    requestJson['puid']= this.puid;
    requestJson['labId']= this.selectedBatch.lab;
    let requestData = JSON.stringify(requestJson);
    formData.append("requestData", requestData);
    formData.append("uploadType", "midplex_tagSorting");
    this.blocked=true
    this.midplexSampleService.getTagSortingFileData(formData).subscribe(
      result => {
        if(result.data){
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'File created',
            detail: 'Tag Sorting File created & stored succesfully',
          });
        this.selectedBatch=result.data;
        this.blocked = false;
        }
      }, error => {
       this.handleError(error);
      }
   )
  }
  downloadTagSort(fileName:string){
   let downloadType="midplex_tagSorting_download";
    let dataToUpload = {"fileName":fileName};
    let jsonString:string= JSON.stringify(dataToUpload);
    this.blocked = true;
    this.midplexSampleService.downloadTagSortFile(downloadType,jsonString).subscribe(
      result => {
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Intiating File download',
          detail: '',
        });
        var blob = new Blob([result.fileContent], { type: 'application/octet-stream' });
        saveByFileSaver(blob, fileName );
        this.blocked = false;
      },
      error => {
        this.handleError(error);
      }
    )
  }

  getAllMergedSamples(){
    this.sourceBatchSamplesMap.forEach((value: CovidSamples[], key: string) => {
      value.forEach(sample=>{
        this.mergedSamples.set(sample.barcode,sample);
      });
    });
  }
  checkTagPlatesDuplicates(tagChangeData:string,type:string){
    this.checkForTagPlateDuplicate=false
    this.checkForTagPlateDuplicateOnChange=false
    let dataForTagplate=[this.selectedTagPlateA1,this.selectedTagPlateA2,this.selectedTagPlateB1,this.selectedTagPlateB2];
    dataForTagplate = dataForTagplate.filter(element=> element!==undefined &&  element!==null);

   let setTagPlates=new Set(dataForTagplate);
   if(type ==="onchange"){
    let getDuplicates=dataForTagplate.filter((element, index, array) => array.indexOf(element) !== index) 
    if(getDuplicates.includes(tagChangeData)){
     this.checkForTagPlateDuplicateOnChange=true
    }
    if(!getDuplicates.includes(tagChangeData) && setTagPlates.size != dataForTagplate.length){
      this.checkForTagPlateDuplicate=true
    }
   }else{
    this.checkForTagPlateDuplicateOnChange = setTagPlates.size != dataForTagplate.length;
   }
   if(this.checkForTagPlateDuplicateOnChange){
    this.checkForTagPlateDuplicate=true
    this._messagesService.addErrorMessage({
      severity: 'error', summary: 'Duplicate Tag Plates!',
      detail: 'Some quadrants have duplicate tag plates...Please choose unique tag plate for each quadrant.'
    });
   }
  }

  getViewPlateIcon(plateViewStatus: boolean) {
    return this.showPlateView ? 'fa fa-list-alt' : 'fa fa-th';
  }

  getPlateViewButtonLabel(plateView: boolean) {
    return plateView ? 'View Batch' : 'View Plate';
  }

  togglePlateView() {
    if(this.showPlateView)
      this.selectedBatch = this.plateViewCmp.onChange();
    this.showPlateView = !this.showPlateView;
  }

  redoSequencing(){
    this.selectedBatch.redoStatus = "Redo Sequencing";
    this.selectedBatch.readyForDeliveryPUID = this.selectedBatch.redoPUID = this.puid;
    this.setMergedBatches('QC Failed');
    this.blocked = true;
    this.midplexSampleService.redoBatch(this.selectedBatch).subscribe(
      result=>{
        this.selectedBatch = result.data;
        this.blocked = false;
        this.commentPopup = false;
        this._messagesService.addSuccessMessage({severity:'success', summary:'Redo Batch Created!', detail:'Redo Batch ' + this.selectedBatch.batchID + ' has been created & old batch has been put to REDO'});
        this.populateBatchHistory();
        this.getSourceBatches();
        this.previewComment = this.getPreviewComment(this.selectedBatch);
        this.commentsMap = new Map<string, Comment[]>();
      },
      error => {
        this.handleError(error);
      }
    )
  }

  showQCOverlay(event:any,op: OverlayPanel){
    this.setMergedBatches('QC OK');
    op.toggle(event);
  }
  
  private setMergedBatches(status: string) {
    this.selectedBatch.mergedBatches.forEach(mb => {
      mb.finalResult = status;
    });
  }

  toggleQCStatus(mergedBatch: MergedBatch){
    mergedBatch.finalResult =  mergedBatch.finalResult === 'QC Failed' ? 'QC OK' : 'QC Failed';
  }

  redoMerging(op: OverlayPanel){
    this.selectedBatch.redoStatus = "Redo Merging";
    this.selectedBatch.readyForDeliveryPUID = this.selectedBatch.redoPUID = this.puid;
    let mergedBatchMap = new Map();
    this.selectedBatch.mergedBatches.forEach(mb => {
      mergedBatchMap.set(mb.batchId, mb.finalResult)
    });
    let mergeSamples = {};
    this.sourceBatchSamplesMap.forEach((value: CovidSamples[], key: string) => {
      if (mergedBatchMap.get(key) != 'QC Failed') {
        value.forEach(sample => {
          mergeSamples[sample.barcode] = sample;
        });
      }
    });
    this.selectedBatch.midplexMergedSamples = mergeSamples;
    this.selectedBatch.labName=this.selectableLab.lab.name;
    this.blocked = true;
    this.midplexSampleService.redoBatch(this.selectedBatch).subscribe(
      result=>{
        this.selectedBatch = result.data;
        this.blocked = false;
        this.commentPopup = false;
        op.hide();
        this._messagesService.addSuccessMessage({severity:'success', summary:'Redo Batch Created!', detail:'Redo Batch ' + this.selectedBatch.batchID + ' has been created & old batch has been put to REDO'});
        this.populateBatchHistory();
        this.getSourceBatches();
        this.previewComment = this.getPreviewComment(this.selectedBatch);
        this.commentsMap = new Map<string, Comment[]>();
      },
      error => {
        this.handleError(error);
      }
    )
  }

  getBackgroundColor(result: string){
    if(result && result != null){
      if(result == 'QC OK')
        return '#28A745';
      else if(result == 'QC Failed')
        return '#DC3545';
    }
  }

  disableRedoMerging() {
    let allQuadrantOK = true;
    if (this.selectedBatch.mergedBatches) {
      this.selectedBatch.mergedBatches.forEach(mergedBatch => {
        if (mergedBatch.finalResult && mergedBatch.finalResult == 'QC Failed')
          allQuadrantOK = false;
      })
      return allQuadrantOK;
    } else {
      return true
    }
  }

  isCommentAdditionDisabled() {
    return (!this.selectedBatch || !this.selectedBatch.batchID || this.selectedBatch.batchID.trim() == '');
  }
  getPreviewComment(batch: Covid19Batch) {
    let comment = new Comment();
    if (batch.comment && (!batch.comments || batch.comments.length == 0)) {
      comment.batchId = batch.batchID;
      comment.puid = '';
      comment.commentDate = null;
      comment.userComment = batch.comment;
      batch.comments.push(comment);
    }

    if (batch.comments && batch.comments.length > 0) {
      comment = batch.comments[batch.comments.length - 1];
    } else {
      comment.userComment = 'No Comments added yet'
    }
    return comment;
  }
  getSourceBatchComment(){
    this.midplexSampleService.getSourceBatchComments(this.selectedLabId, this.selectedBatch.sourceBatchIds.join(',')).subscribe(
      results=>{
        this.sourceBatchCommentsMap = new Map(Object.entries(results.data));
        this.getArrayOfCommentsForSourceBatch();
      },
      error=>{
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    )
}
  showComments() {
    this.commentsMap = new Map<string, Comment[]>();
    this.formCommentsMap(this.selectedBatch.comments);
    if(this.selectedBatch.wellType == 'WELL384' && this.sourceCommentsFlagIndicator){
      this.sourceBatchCommt.forEach(comment => {
        let cmnt = this.getArrayOfCommentsForSource(comment.batchId, comment);
        this.commentsMap.set(comment.batchId, cmnt);
        this.batchCommentVisibility.set(comment.batchId, true);
      });
  }
    this.newComment = this.initializeNewComment();

    this.showCommentDialog = true;
  }
  getArrayOfCommentsForSourceBatch() {
    this.sourceBatchCommt=[];
      this.sourceBatchCommentsMap.forEach((Value, Key) => {
        if(Value){
          Value.forEach(index => {
              this.sourceCommentsFlagIndicator=true;
              this.sourceBatchCommt.push(Object.assign({}, index));
          });
        }
      });
  }
  getArrayOfCommentsForSource(batchID: string, comment: Comment) {
    let commentItem = this.commentsMap.get(batchID);
    if (!commentItem) {
      commentItem = [];
    }
    if(comment.commentDate['$date']){
      comment.commentDate = comment.commentDate['$date'];
    }
    commentItem.push(Object.assign({}, comment));
    return commentItem;
  }
  formCommentsMap(comments: Comment[]) {
    if (!comments || this.commentsMap.size != 0) {
      return;
    }
    this.batchCommentVisibility = new Map<string, boolean>();
    comments.forEach(comment => {
      let cmnt = this.getArrayOfCommentsToAnother(comment.batchId, comment);
      this.commentsMap.set(comment.batchId, cmnt);
      this.batchCommentVisibility.set(comment.batchId, true);
    });
  }

  initializeNewComment() {
    let comment = new Comment();
    comment.batchId = this.selectedBatch.batchID;
    comment.puid = this.puid;

    return comment;
  }

  getArrayOfCommentsToAnother(batchID: string, comment: Comment) {
    let commentItem = this.commentsMap.get(batchID);
    if (!commentItem) {
      commentItem = [];
    }
    commentItem.push(Object.assign({}, comment));
    return commentItem;
  }
  getCommentKeys(commentMap: Map<string, Comment[]>) {
    return Array.from(commentMap.keys());
  }

  toggleBatchContent(batchID: string, showState: boolean) {
    this.batchCommentVisibility.set(batchID, showState);
  }
  saveComment() {
    if (!this.selectedBatch.batchID || this.selectedBatch.batchID.trim() == '') {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Batch ID Empty', detail: 'Please enter Batch ID to save' });
      return;
    }
    if (!this.isPUIDPresnt()) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'User ID Empty', detail: 'Please enter User ID to save' });
      return;
    }
    this.blocked = true;
    this.newComment.commentDate = new Date();
    this.newComment.userComment = this.newComment.userComment.trim();
    this.selectedBatch.comments.push(this.newComment);
    this.apgTestingService.saveComment(this.selectedBatch.batchID, this.selectedLabId, this.selectedBatch.comments).subscribe(
      result => {
        this.selectedBatch = result.data;
        this.previewComment = this.newComment;
        let cmnt = this.getArrayOfCommentsToAnother(this.selectedBatch.batchID, this.newComment);
        this.commentsMap.set(this.selectedBatch.batchID, cmnt);
        this.batchCommentVisibility.set(this.selectedBatch.batchID, true);
        this.newComment = this.initializeNewComment();
        this.blocked = false;
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Comment Saved', detail: 'Comment saved successfully' });
      },
      error => {
        this.handleError(error);
      }
    );
  }

  disableCreateSampleButton(){
    return this.disableCompletePurification()  || this.selectedBatch.nglimsProjectId;
    }

  createPoolIdForTheBatch() {
      this.selectedBatch.type = "Midplex";
      this.blocked = true;
      this.midplexSampleService.createPoolIdForTheBatch(this.selectedBatch).subscribe(
        result => {
          let srResponse = result.data;
          this.selectedBatch.nglimsSampleCreationPUID = this.puid;
          this.selectedBatch.nglimsSampleCreationDateTime = new Date();
          this.selectedBatch.nglimsProjectId = this.selectedBatch.mergedBatches[0].coProjectId;
          this.selectedBatch.nglimsSampleId = this.selectedBatch.batchID.substring(this.selectedBatch.batchID.split('_', 2).join('_').length + 1, this.selectedBatch.batchID.length);;
         
       
           this.selectedBatch.mergedBatches.forEach(batch=> {
            let poolResponse =  srResponse[batch.quadrant];
            batch.libraryId = poolResponse["barcode"];

           });

          this.selectedBatch.libraryId = srResponse.barcode;
          this.selectedBatch.mintUUID = srResponse.libraryId;
          this.saveBatchData();
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Library created in MINT successfully',
            detail: '' ,
          });
          this.blocked = false;
        },
        error => {
          this.blocked = false;
          let apiErrormessage = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(apiErrormessage);
        }
      )
  
    }
}